import script from "./fundsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./fundsView.vue?vue&type=script&setup=true&lang=ts"

import "./fundsView.vue?vue&type=style&index=0&id=7115a3e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7115a3e0"]])

export default __exports__